// Same-tab session marker so a refresh does not show the form again for 5 hours.
// sessionStorage is per tab: a new tab, a fresh link click or another device always starts at the form.
const KEY = "vs_webinar_session";
const MAX_AGE_MS = 5 * 60 * 60 * 1000;

export function saveSession(viewer, utm) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ verified: true, verifiedAt: Date.now(), ...viewer, ...utm }));
  } catch (err) {
    console.warn("sessionStorage unavailable, access will not survive a refresh:", err);
  }
}

export function loadSession() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const s = JSON.parse(raw);
    const fresh = s && s.verified === true && typeof s.verifiedAt === "number" && Date.now() - s.verifiedAt < MAX_AGE_MS;
    if (!fresh || !s.name || !s.leadId) {
      sessionStorage.removeItem(KEY);
      return null;
    }
    return { name: s.name, phone: s.phone, email: s.email, leadId: s.leadId };
  } catch (err) {
    console.warn("sessionStorage unavailable:", err);
    return null;
  }
}
